<form novalidate #adminForm="ngForm">
  <kendo-grid [data]="view | async"
              [ngClass]="{'grid': !gridIsChild, 'kendo-child-grid': gridIsChild}"
              [pageSize]="gridState.take"
              [pageable]="true"
              [size]="'none'"
              [skip]="gridState.skip"
              [sort]="gridState.sort"
              [sortable]="{mode: 'multiple'}"
              [filter]="gridState.filter"
              [filterable]="true"
              [virtualColumns]="true"
              [scrollable]="true"
              (dataStateChange)="onStateChange($event)"
              (cancel)="cancelHandler($event)"
              (save)="saveHandler($event)"
              (edit)="editHandler($event)"
              (remove)="removeHandler($event)"
              (add)="addHandler($event)">
    <ng-template kendoGridToolbarTemplate>
      @if (CanExport)
      {
      <button type="button" kendoGridExcelCommand size="small" rounded="medium" fillMode="solid" [disabled]="(!kendoGridService.serverPaging && (!gridAllData || gridAllData.length===0)) || saveInProgress"><kendo-svg-icon style=" margin-right: 5px; margin-bottom: 1px;" [icon]="icons.excel"></kendo-svg-icon>Export to Excel</button>
      }
    </ng-template>
    <kendo-grid-column field="Id" title="Id" width="100px" [locked]="true">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <kendo-numerictextbox-filter [filter]="filter"
                                     filterBy="Id">
        </kendo-numerictextbox-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
        {{dataItem.Id}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="CategoryName" title="Category" width="250px" [locked]="true">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <kendo-textbox-filter [filter]="filter"
                              filterBy="CategoryName">
        </kendo-textbox-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
        {{dataItem.CategoryName}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="PropertyName" title="Property" width="350px" [locked]="true">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <kendo-textbox-filter [filter]="filter"
                              filterBy="PropertyName"
                              filterById="PropertyId">
        </kendo-textbox-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
        {{dataItem.PropertyName}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="PropertyTypeName" title="Property Type" width="150px">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <kendo-textbox-filter [filter]="filter"
                              filterBy="PropertyTypeName">
        </kendo-textbox-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
        {{dataItem.PropertyTypeName}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="StationsSortKey" title="Platform Provider" width="400px">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <kendo-textbox-filter [filter]="filter"
                              filterBy="Stations">
        </kendo-textbox-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
        {{dataItem.Stations}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="StartDate" title="First Date" width="170px" filter="date" format="{0:d}">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{dataItem.StartDate | date }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="EndDate" title="Last Date" width="170px" filter="date" format="{0:d}">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{dataItem.EndDate | date }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="Disabled" headerClass="kendo-grid-header-center" class="kendo-grid-column-center" title="Disabled" width="80px">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <kendo-checkbox-filter [filter]="filter"
                               filterBy="Disabled">
        </kendo-checkbox-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{dataItem.Disabled ? "Disabled" : "Enabled"}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-command-column title="" width="100px">
      <ng-template kendoGridHeaderTemplate>
        @if (CanAdd)
        {
        <kendo-button-filter (buttonClicked)="addNew($event)" buttonTitle="add" buttonIcon="add_box" style="padding-left: 42px !important">
        </kendo-button-filter>
        }
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        @if (CanEdit)
        {
        <button mat-icon-button color="accent" (click)="editItem(dataItem)" (mouseenter)="propertyHover($event, dataItem.Id)" title="edit">
          <mat-icon aria-label="Edit">edit</mat-icon>
        </button>
        }
        @if (CanDelete)
        {
        <button mat-icon-button color="accent" (click)="deleteItem($event, dataItem)" title="delete">
          <mat-icon aria-label="Delete">delete</mat-icon>
        </button>
        }
      </ng-template>
    </kendo-grid-command-column>
    <kendo-grid-excel fileName="PropertiesSearch.xlsx" [fetchData]="exportData"></kendo-grid-excel>
    <ng-template kendoPagerTemplate
                 let-total="total"
                 let-pageSize="pageSize"
                 let-currentPage="currentPage">
      <mat-paginator #paginator
                     [length]="total"
                     [pageIndex]="currentPage-1"
                     [pageSize]="pageSize"
                     [pageSizeOptions]="kendoGridService.pagerPageSizes"
                     showFirstLastButtons="true"
                     (page)="page($event)">
      </mat-paginator>
    </ng-template>
  </kendo-grid>
</form>

